const log = {
    invalid_type: 'Geçersiz günlük türü.',
};
export default Object.freeze(log);
